module.exports = __webpack_public_path__ + "img/success.53c61e8f.png";